
import { defineComponent, inject } from 'vue'
import CloseSvg from '@/components/svgs/CloseSvg.vue'
import { PROVIDER_CONSTANTS } from '@/constants/provider.constants'
import Toaster from '@meforma/vue-toaster'
import InventorySearch from '@/components/elements/InventorySearch.vue'
import { InventoryItem } from '@/@types/responses/inventory_item/InventoryItem'

export default defineComponent({
  name: 'SelectPartModal',
  components: {
    CloseSvg,
    InventorySearch
  },
  props: {
    supplierId: {
      type: Number,
      default: undefined
    }
  },
  emits: ['close', 'inventory-item'],
  setup() {
    const toast = inject(PROVIDER_CONSTANTS.toaster) as Toaster

    return {
      toast
    }
  },
  mounted() {
    document.body.addEventListener('keyup', this.onKeyup)
  },
  unmounted() {
    document.body.removeEventListener('keyup', this.onKeyup)
  },
  methods: {
    onCloseClicked(): void {
      this.$emit('close')
    },
    onKeyup(e: KeyboardEvent): void {
      if (e.key === 'Escape' || e.key === 'Esc')
        this.onCloseClicked()
    },
    onInventoryItemSelected(inventoryItem: InventoryItem): void {
      this.$emit('inventory-item', inventoryItem)
    }
  }
})
